import * as r from '@recoiljs/refine';
import { atom } from 'recoil';
import { urlSyncEffect } from 'recoil-sync';

const stringArrayChecker = r.withDefault(r.array(r.string()), []) as r.Checker<
	string[]
>;
export interface RequirementControlAtom extends Record<string, string[]> {
	employee: string[];
	generalInformationJobTitle: string[];
	management: string[];
	coordination: string[];
	pole: string[];
	workStation: string[];
	status: string[];
	situation: string[];
	requirementType: string[];
	requirementClass: string[];
	requirement: string[];
}

export const requirementControlAtom = atom<RequirementControlAtom>({
	key: 'requirementControl',
	default: {
		employee: [],
		generalInformationJobTitle: [],
		management: [],
		coordination: [],
		pole: [],
		workStation: [],
		status: [],
		situation: [],
		requirementType: [],
		requirementClass: [],
		requirement: [],
	},
	effects: [
		urlSyncEffect<RequirementControlAtom>({
			refine: r.object({
				employee: stringArrayChecker,
				generalInformationJobTitle: stringArrayChecker,
				management: stringArrayChecker,
				coordination: stringArrayChecker,
				pole: stringArrayChecker,
				workStation: stringArrayChecker,
				status: stringArrayChecker,
				situation: stringArrayChecker,
				requirementType: stringArrayChecker,
				requirementClass: stringArrayChecker,
				requirement: stringArrayChecker,
			}),
			history: 'push',
		}),
	],
});
